// extracted by mini-css-extract-plugin
export default {"listBox":"ReportsListWidget_listBox__ikaJU","list":"ReportsListWidget_list__oJ7Xh","buttons":"ReportsListWidget_buttons__mt+KU"};